import { Box, Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import useCollapseDrawer from 'hooks/useCollapseDrawer';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { HEADER, NAVBAR, PATH_AFTER_LOGIN } from '../../config';
import DashboardHeader from './header';

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})(({ collapseClick, theme }) => ({
  flexGrow: 1,
  paddingTop: HEADER.MOBILE_HEIGHT + 24,
  paddingBottom: HEADER.MOBILE_HEIGHT + 24,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    transition: theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter,
    }),
    ...(collapseClick && {
      marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
    }),
  },
}));

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const { collapseClick, isCollapse } = useCollapseDrawer();
  const isHome = pathname === '/';

  if (isHome) {
    return <Navigate to={PATH_AFTER_LOGIN} />;
  }

  const isCompanyListPage = pathname === '/company/list';

  return (
    <Box
      sx={{
        display: { lg: 'flex' },
        minHeight: { lg: 1 },
      }}
    >
      <DashboardHeader isCollapse={isCollapse} />

      <MainStyle collapseClick={collapseClick}>
        <Container maxWidth={isCompanyListPage ? 'lg' : 'xl'}>
          <Outlet />
        </Container>
      </MainStyle>
    </Box>
  );
}
